// mock docs: http://yapi.sui.work/project/58/interface/case/6778
import request from './request'
import { ACT_CODE } from '$utils/act-config'

const request2 = (url: string, reqbody = {}, reqConfig = {}) => {
  return request(url, {
    actCode: ACT_CODE,
    ...reqbody
  }, {
    ...reqConfig
  })
}

/** 查询活动信息 不需登录 */
export const queryActConf = (parmas: any = {}) => {
  return request2('/finance-common-operation-ws/api/act/activity/v1/actConf', parmas, { loading: true })
}

/** 查询活动下面的所有分值信息 */
export const queryIntegral = (parmas: any = {}) => {
  return request2('/finance-common-operation-ws/api/integral/queryIntegralConfigByActCode', parmas, { loading: true })
}

/** 落地页--规则组资格校验 */
// export const ruleCheck = (parmas: any) => {
//   return request2('/finance-common-operation-ws/api/act/activity/v1/ruleCheck', parmas, { loading: true })
// }

/** 同步规则判定触发抽奖(支持传多个规则组代码) */
export const synRuleDrawEnhance = (parmas: any = {}) => {
  return request2('/finance-common-operation-ws/api/act/rule/v1/synRuleDrawEnhance', parmas, { loading: true })
}
/** 分值抽奖-增强版 */
export const integralDrawEnhance = (parmas: any = {}) => {
  return request2('/finance-common-operation-ws/api/integral/integralDrawEnhance', parmas, { loading: false })
}

/** 获取分享链接及加密参数 */
// export const getShareUrl = () => {
//   return request2('/finance-common-operation-ws/api/act/invitation/v1/getShareUrl')
// }